import { Component, inject, signal, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { DemandesService } from '../../../../core/service/demandes-service/demandes.service';
import { SeasonsService, LicencePeriod } from '../../../../core/service/seasons-service/seasons.service';
import { PermissionService } from '../../../../core/service/permission/permission.service';
import { environment } from '../../../../../environments/environment';
import { SwalUtils } from '../../../../shared/utils/swal.utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-demande-submit',
  standalone: false,
  templateUrl: './demande-submit.component.html',
})
export class DemandeSubmitComponent implements OnInit {
  @Input() entityType: string = 'player';
  @Input() entityId!: number;

  private demandesService = inject(DemandesService);
  private seasonsService = inject(SeasonsService);
  permService = inject(PermissionService);

  isSubmitting = signal(false);
  isLoadingPeriods = signal(true);
  licencePeriods = signal<LicencePeriod[]>([]);

  form = {
    demande_type: 'NEW',
    licenceperiod_id: null as number | null,
    motif: '',
  };

  demandeTypes: Record<string, { value: string; label: string }[]> = {
    player: [
      { value: 'NEW',      label: 'Nouvelle licence' },
      { value: 'RENEW',    label: 'Renouvellement' },
      { value: 'TRANSFER', label: 'Transfert' },
      { value: 'EDIT',     label: 'Modification' },
    ],
    manager: [
      { value: 'NEW',   label: 'Nouvelle licence' },
      { value: 'RENEW', label: 'Renouvellement' },
      { value: 'EDIT',  label: 'Modification' },
    ],
    staff: [
      { value: 'NEW',   label: 'Nouvelle licence' },
      { value: 'RENEW', label: 'Renouvellement' },
      { value: 'EDIT',  label: 'Modification' },
    ],
    referee: [
      { value: 'NEW',   label: 'Nouvelle licence' },
      { value: 'RENEW', label: 'Renouvellement' },
      { value: 'EDIT',  label: 'Modification' },
    ],
  };

  ngOnInit(): void {
    if (environment.action_block) return;
    this.seasonsService.getActive().subscribe({
      next: (res) => {
        const season = res?.data;
        if (!season?.sportseason_id) {
          this.isLoadingPeriods.set(false);
          return;
        }
        this.seasonsService.getLicencePeriods(season.sportseason_id).subscribe({
          next: (periodsRes) => {
            const periods: LicencePeriod[] = (periodsRes?.data || []).filter(
              (p: LicencePeriod) => p.licenceperiod_status === 'OPEN'
            );
            this.licencePeriods.set(periods);
            if (periods.length > 0) {
              this.form.licenceperiod_id = periods[0].licenceperiod_id;
            }
            this.isLoadingPeriods.set(false);
          },
          error: () => {
            this.isLoadingPeriods.set(false);
          },
        });
      },
      error: () => {
        this.isLoadingPeriods.set(false);
      },
    });
  }

  get currentDemandeTypes(): { value: string; label: string }[] {
    return this.demandeTypes[this.entityType] ?? this.demandeTypes['player'];
  }

  submit(): void {
    if (this.isSubmitting()) return;
    this.isSubmitting.set(true);
    this.demandesService.submit(this.entityType, {
      entity_id: this.entityId,
      demande_type: this.form.demande_type,
      licenceperiod_id: this.form.licenceperiod_id,
      motif: this.form.motif,
    }).subscribe({
      next: () => {
        SwalUtils.success('Demande soumise', 'Votre demande a été envoyée avec succès');
        this.isSubmitting.set(false);
        this.form.motif = '';
      },
      error: () => {
        SwalUtils.error('Erreur', 'Erreur lors de la soumission de la demande');
        this.isSubmitting.set(false);
      },
    });
  }
}
